import { useState } from 'react';

import { Form, Table, TableProps } from 'antd';
import { editableTableModel } from 'components/editable-table';
import { useMessageLogger } from 'hooks/useMessageLogger';
import { Mutation } from 'models/helper';

import { EditableCell } from './editable-cell';
import { DataType } from '../lib';

interface EditableTableProps extends TableProps<DataType> {
  mutation: Mutation;
}

const EditableTable = ({ mutation, columns, ...rest }: EditableTableProps) => {
  const [editingKey, setEditingKey] = useState<React.Key>('');
  const [form] = Form.useForm();

  const [mutationReq, { error, status }] = mutation;

  const formattedColumns =
    columns && editableTableModel.formatColumns({ columns, editingKey, setEditingKey, form, mutationReq });

  useMessageLogger({ error, status, successMessage: 'Информация обновлена' });

  return (
    <Form form={form} component={false}>
      <Table
        pagination={{ hideOnSinglePage: true }}
        columns={formattedColumns}
        components={{ body: { cell: EditableCell } }}
        {...rest}
      />
    </Form>
  );
};

export { renderEdit } from './editable-cell';

export default EditableTable;
